import { InputsForm } from "@/Components/Index";
import { LayoutCheckoutForm } from "@/Layout/Checkout/LayoutCheckoutForm";
import type { MBuyCarCheckout } from "@/Models/MBuyCarCheckout/MBuyCarCheckout";
import type { MCheckout } from "@/Models/MCheckout/MCheckout";
import React, { useState } from "react";

type Props = {
  MDatos: MCheckout[];
  headleOnClickFrom: (value: MBuyCarCheckout) => void;
  isLoading: boolean;
};

export const FormPickUp: React.FC<Props> = ({
  MDatos,
  headleOnClickFrom,
  isLoading
}: Props) => {
  const { ipAddress, basketId, quant, totalSalesPrice } = MDatos[0] ?? {};

  //guardar los datos del usuario
  const [formDataTicket, setformDataTicket] = useState<MBuyCarCheckout>({
    postalCode: "", //number
    cColonia: "",
    address1: "",
    cStreetNumber: "", //number
    interNumber: "",
    reference: "",
    city: "",
    stateCode: "",
    firstName: "Ariel",
    phone: "8711435934", //number
    countryCode: "MX", //mx mexico
    companyName: "",
    fullName: "",
    lastName: "Mata",
    //Importantes
    id: basketId ?? "", //basketId
    //Importantes
    ipAddress: ipAddress ?? "",
    priceSale: totalSalesPrice ?? 0,
    Quantity: quant ?? 0,
    email: "ariel@develop.mx",
  });

  //habilitar el boton
  const [Avility, setAvility] = useState<boolean>(false);

  const checkEmptyOrFalseFields = (): (keyof MBuyCarCheckout)[] => {
    // Crear un array para guardar los campos vacíos o en false
    const emptyOrFalseFields = (
      Object.keys(formDataTicket) as (keyof MBuyCarCheckout)[]
    ).filter((key) => {
      const values = formDataTicket[key];
      return values === "";
    });

    return emptyOrFalseFields;
  };

  const handleChangue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    setformDataTicket({
      ...formDataTicket,
      [name]: value,
    });
    //const invalidFields = checkEmptyOrFalseFields();
    //const ActivoButton = invalidFields.length > 0 ? false : true;
    //setAvility(ActivoButton);
  };

  //solo permite números y backspace
  const handdleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!/[0-9]/.test(e.key) && e.key !== "Backspace") e.preventDefault();
  };

  const handleSubmit = () => {
    //const invalidFields = checkEmptyOrFalseFields();
    //if (invalidFields.length === 0) {
    headleOnClickFrom(formDataTicket);
    //}
  };

  //**********************************************************//
  const InputsComponetsDataText = (
    types: string,
    names: string,
    placeholders: string,
    values: string
  ) => (
    <input
      type={types}
      className="form-control develop__inputs"
      id={names}
      name={names}
      placeholder={placeholders}
      onChange={handleChangue}
      value={values}
    />
  );

  const InputsComponetsDataNumber = (
    names: string,
    placeholders: string,
    values: string
  ) => (
    <input
      type="text"
      className="form-control develop__inputs"
      id={names}
      name={names}
      placeholder={placeholders}
      onChange={handleChangue}
      value={values}
      onKeyDown={handdleKeyDown}
    />
  );
  return (
    <LayoutCheckoutForm handleSubmit={handleSubmit} isLoading={isLoading}>
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <InputsForm idx={"firstName"} titlesx={"Nombre(s)"}>
            {InputsComponetsDataText(
              "text",
              "firstName",
              "* Nombre(s)",
              formDataTicket.firstName
            )}
          </InputsForm>
        </div>
        <div className="col-xl-12 col-md-12">
          <InputsForm idx={"lastName"} titlesx={"Apellido(s)"}>
            {InputsComponetsDataText(
              "text",
              "lastName",
              "* Apellido(s)",
              formDataTicket.lastName
            )}
          </InputsForm>
        </div>
        <div className="col-xl-12 col-md-12">
          <InputsForm idx={"phone"} titlesx={"Teléfono"}>
            {InputsComponetsDataNumber(
              "phone",
              "* Teléfono",
              formDataTicket.phone
            )}
          </InputsForm>
        </div>
        <div className="col-xl-12 col-md-12">
          <InputsForm idx={"email"} titlesx={"Correo electronico"}>
            {InputsComponetsDataText(
              "email",
              "email",
              "* Correo electronico",
              formDataTicket.email
            )}
          </InputsForm>
        </div>
      </div>
    </LayoutCheckoutForm>
  );
};
